import React, { Component, Fragment } from 'react';
import { Link } from 'react-router';
import { connect } from 'react-redux';
import { withSnackbar } from 'notistack';
import { Grid, Paper } from '@material-ui/core';
import { TableListComp, PageLoader, ExportManu, EmptyCollection, FilterComponent, } from '../../../shared_elements';
import { STableLoader } from '../../../shared_elements/loaders';
import { FleetClaimsRow } from '../components';
import { getPlatformConstantsLeaseStatusAc } from '../../../shared_elements/actionCreators';
import { getLocalStorageInfo, } from '../../../utils_v2';
import { getFleetClaimsApi, getAssetIdentifierApi, getAssemblyApi, exportFleetClaimApi, } from '../apiServices';
import { claimFleetFilterOps, claimFleetHd, globalFilterTypes } from '..'
import { trackActivity } from '../../../utils/mixpanel';
import DeploymentMessage from '../../../shared_elements/components/DeploymentMessage';
import RoleBasedAccess from '../../../utils/RoleBasedAccess';
import restrictIcon from '../../../shared/assets/img/restrict_icon.svg';
import ClaimFilterComponent from '../components/ClaimFilter';

class FleetClaims extends Component {
  constructor(props) {
    super(props);
    this.state = {
      skeletonLoader: false,
      pageLoader: false,
      open: false,
      invoices: { list: [], pagination: { per_page: 50 } },
      sort: '',
      sort_by: '',
      filter: {},
      assetTypeOptions: [],
      assetModelOptions: [],
      assetsOptions: [],
      assemblyOptions: [],
      lessorOptions: [],
      ownerOptions: [],
      lesseeFilter: [],
      filterOption: {},
      isOpen: false
    };
    this.getFleetClaimsApi = getFleetClaimsApi.bind(this);
    this.getAssemblyApi = getAssemblyApi.bind(this);
    this.exportFleetInvoicesApi = exportFleetClaimApi.bind(this);
    this.getAssetIdentifierApi = getAssetIdentifierApi.bind(this);
  }
  componentDidMount() {
    this.getFleetClaimsApi(this.props, { per_page: 50 }, 'skeletonLoader');
    this.getAssemblyApi();
    this.props.getPlatformConstantsLeaseStatus();
    globalFilterTypes.map((item) => this.getAssetIdentifierApi(item.label, item.type))
    trackActivity('Lease Management', {
      event_type: 'Page Visited',
      page_title: 'Fleet Claim List'
    });
  }
  createSortHandler = (sortField) => {
    const { sort, sort_by, filter } = this.state;
    this.setState({
      sort: sortField,
      sort_by: (sortField === sort ? sort_by === 'asc' ? 'desc' : 'asc' : 'asc')
    });
    if (sortField === sort) {
      if (sort_by === 'asc') {
        this.getFleetClaimsApi(this.props, { ...filter, sort: sortField, sort_by: 'desc', per_page: 50 }, 'pageLoader');
      } else {
        this.getFleetClaimsApi(this.props, { ...filter, sort: sortField, sort_by: 'asc', per_page: 50 }, 'pageLoader');
      }
    } else {
      this.getFleetClaimsApi(this.props, { ...filter, sort: sortField, sort_by: 'asc', per_page: 50 }, 'pageLoader');
    }
  }
  render() {
    const { skeletonLoader, pageLoader, filter, invoices, sort, sort_by, assemblyOptions, assetModelOptions, assetTypeOptions, assetsOptions, } = this.state;
    let filterOptions = Object.assign({}, claimFleetFilterOps);
    const neededAssetType = ['Aircraft', 'APU', 'Landing Gear', 'Engine'];
    const updatedAssetTypeOptions = assetTypeOptions.filter(item => neededAssetType.includes(item.name));
    filterOptions = {
      ...filterOptions,
      asset_type: {
        ...filterOptions.asset_type,
        options: updatedAssetTypeOptions
      },
      major_assemblies: {
        ...filterOptions.major_assemblies,
        options: assemblyOptions
      },
      asset_model: {
        ...filterOptions.asset_model,
        options: assetModelOptions
      },
      serial_number: {
        ...filterOptions.serial_number,
        options: assetsOptions
      }
    }

    let isJac = getLocalStorageInfo().defaultLessor.id === 442 ? true : false
    return (
      <section className="fleet-lease-management-sec">
        {!getLocalStorageInfo()?.defaultLessor?.is_maintenance_enable ? <div>
          <Grid xs="12" style={{ minHeight: '90vh', position: 'relative' }}>
            <div className="page-not-found">
              <img src={restrictIcon} alt="Icon" />
              <h2>You’re not permitted to see this.</h2>
              <p>The page you’re trying to access has restricted access,<br />
                please contact <a style={{ color: '#3F51B5', textDecoration: 'auto' }} href="mailto:support@sparta.aero">support@sparta.aero</a> to access this application.
              </p>
              <Link className="start-over btn btn-default return-home" onClick={() => window.location.assign("https://sparta.aero")}>Return Home</Link>
            </div>
          </Grid>
        </div> :
          <>  <DeploymentMessage />
            <Fragment>
              {skeletonLoader ? <STableLoader count={8} /> :
                <Fragment>
                  <Paper square style={{ padding: '6px 10px' }}>
                    <Grid container spacing={1} alignItems='center'>
                      <Grid item md={9}>
                        <ClaimFilterComponent
                          filter={filter}
                          filterMenu={filterOptions}
                          getResponseBack={(applyFilter) => {
                           this.getFleetClaimsApi(this.props, { ...applyFilter, page: 1, per_page: invoices.pagination.per_page }, 'pageLoader') }}
                        />
                      </Grid>
                      <Grid item md={3}>
                        <ul className="list-inline" style={{ float: 'right', display: 'flex' }}>
                          {invoices?.list?.length > 0
                            // && checkPermission('contracts', 'claims', 'EXP') 
                            &&
                            <li className="list-inline-item">
                              <ExportManu title="Export" files={[{ title: 'Excel', extension: 'xlsx', key: '' },]} exportReportFn={(file) => this.exportFleetInvoicesApi(this.props, { ...filter, download: file.extension })} />
                            </li>
                          }
                        </ul>
                      </Grid>
                    </Grid>
                  </Paper>

                  <TableListComp
                    heads={claimFleetHd}
                    sort={sort}
                    maxheight={isJac ? filter && Object.keys(filter).length > 3 ? window.innerHeight - 250 + 'px' : window.innerHeight - 220 + 'px' : filter && Object.keys(filter).length > 3 ? window.innerHeight - 210 + 'px' : ''}
                    bulkOperation={false}
                    sort_by={sort_by}
                    data={invoices.list.map((item, index) =>
                      <FleetClaimsRow
                        index={index}
                        item={item} />
                    )
                    }
                    createSortHandler={this.createSortHandler}
                    onChangePage={(event, newPage) => { this.getFleetClaimsApi(this.props, { ...filter, page: newPage + 1, per_page: invoices.pagination.per_page, sort: sort, sort_by: sort_by }, 'pageLoader') }}
                    onChangeRowsPerPage={(event) => { this.getFleetClaimsApi(this.props, { ...filter, page: 1, per_page: event.target.value, sort: sort, sort_by: sort_by }, 'pageLoader') }}
                    pagination={invoices.pagination}
                    noRecord={invoices.list.length ? null :
                      <EmptyCollection
                        title="No records found"
                      />
                    }
                  />
                </Fragment>
              }
            </Fragment>
            {pageLoader ? <PageLoader /> : null}</>}

      </section>
    )
  }
}
const mapStateToProps = state => ({
  pltConstantsLeaseStatus: state.shareReducer.pltConstantsLeaseStatus
})
const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    getPlatformConstantsLeaseStatus: () => dispatch(getPlatformConstantsLeaseStatusAc({ constant_types: ['lease_status'] }))
  }
}
export default withSnackbar(connect(mapStateToProps, mapDispatchToProps)(RoleBasedAccess(FleetClaims, ['contracts', 'invoices', 'R'])))
